<template>
  <div class="container">
    <div style="display:flex ; justify-content:space-between;" >
      <div v-if="addButton && this.$store.state.user.roles[0].name != 'Goverment'" >
        <div  style="cursor: pointer;font-weight: bold;padding-top:16px ;" @click="$emit('added')">
          {{ $t("dispatching.logsTable.fileAComplaint") }}
        </div>
       
      </div>
        <div v-if="addButton" style="width: 220px">
          <v-select v-if="logs.length>0 && this.$store.state.user.roles[0].name == 'Goverment'" v-model="complaintStatusModel" @change="$emit('changeComplaintStatus', $event)" color="error"
            :items="complaintStatusItems" :label="$t('common.status')" outline></v-select>
        </div>
    </div>
    <table>
  
      <!-- <tr v-if="addButton"> -->
        <!-- <th>ID</th> -->
        <!-- <th>Title</th> -->
        <!-- <th>Des</th> -->
        <!-- <th>Captain</th> -->
        <!-- <th>Date</th> -->
      <!-- </tr> -->
      <tr
        style="cursor: pointer;"
        v-for="(log, index) in logs"
        @click="$emit('showDetails', log, log.id)"
      >
        <th>
          <div
            v-if="colorCoding && colorCoding[log[colorCodingKey]]"
            class="circle"
            :style="`background:${colorCoding[log[colorCodingKey]]};`"
          ></div>
          <span v-else>{{ index + 1 }}</span>
        </th>
        <th style="max-width: 100px;"><span>{{ log[titleKey] }}</span></th>
        <th style="max-width: 80px; font-weight: normal; color: #788E98; padding-left: 4px;" v-if="doerKey"><span>{{ $t("dispatching.logsTable.by", { name: log[doerKey] }) }}</span></th>
        <!-- <th>{{ log[CaptainKey] }}</th> -->
        <td>{{ moment(log[datetimeKey]).format("HH[h]mm DD/MM/YYYY") }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "LogTable",
  data() {
    return {complaintStatusModel:'Not Treated'};
  },
  computed: {
    complaintStatusItems() {
      return [
        { text: this.$t("dispatching.logsTable.notTreated"), value: "Not Treated" },
        { text: this.$t("dispatching.logsTable.partiallyTreated"), value: "Partially Treated" },
        { text: this.$t("dispatching.logsTable.treated"), value: "Treated" },
      ];
    },
  },
  mounted (){
    this.complaintStatusModel = this.complaintStatus;
  },
  watch: {
    complaintStatus(val) {
      this.complaintStatusModel = val;
    }
  },
  props: {
    complaintStatus: {
      required:false
    },
    logs: {
      required: true,
    },
    titleKey: {
      required: true,
      type: String,
    },
    datetimeKey: {
      required: true,
      type: String,
    },
    colorCoding: {
      required: false,
    },
    addButton: {
      required: false,
    },
    colorCodingKey: {
      required: false
    },
    doerKey: {
      required: false,
      type: String,
      default: null
    },
    CaptainKey: {
      required: false,
      type: String,
      default: null
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: auto;
  float: left;
  padding: 1rem 1.25rem;
  background: white;
  max-height: 400px;
  border-radius: 8px;
  box-shadow: 0px 0px 6px rgba($color: #000000, $alpha: 0.08);
  overflow-y: overlay;

  &::-webkit-scrollbar {
    width: 0.2em;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c1c5d8;
    border-radius: 9999px;
  }

  table {
    width: 100%;
    float: left;
    font-size: 14px;
    border-spacing: 0px 16px;
    tr {
    
      td {
        text-align: left;
      }
      th {
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      th:first-child {
        padding-right: 0.5rem;
        .circle {
          border-radius: 100%;
          width: 15px;
          height: 15px;
          float: left;
        }
      }
    }
  }
}
</style>
